import axios from "axios";

export const irentAPI = axios.create({
  baseURL: process.env.VUE_APP_APIURL,
  headers: { "Content-Type": "application/json" },
});

export const editorAPI = axios.create({
  baseURL: process.env.VUE_APP_EDITOR_APIURL,
  headers: {
    "Content-Type": "application/json",
    "X-Apliccation-Origin": "webs_individuals_script",
  },
});
